import React, { useState, useRef, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import {
  MdSearch,
  MdNotifications,
  MdPerson,
  MdSettings,
  MdClose,
  MdMenu,
} from "react-icons/md";
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi";
import Swal from "sweetalert2";
import axios from "axios";
import MyContext from "../../../context/MyContext";
import "../../../assets/css/components/deliveryPanel/deliveryTopbar/DeliveryTopbar.css";

const getTimeAgo = (dateString) => {
  const seconds = Math.floor((new Date() - new Date(dateString)) / 1000);
  if (seconds < 60) return "Just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  const days = Math.floor(hours / 24);
  return `${days} day${days > 1 ? "s" : ""} ago`;
};

// Notification "unread" ki definition robust ban chuki hai — status ki value
// database mein 'unread', 'Unread', ya kabhi kabhi garbage (0, null) bhi ho
// sakti hai. Is liye "read" ke elawa sab kuch unread mana jata hai.
const isUnread = (status) => String(status).toLowerCase() !== "read";

const DeliveryTopbar = ({
  isCollapsed,
  setIsCollapsed,
  isMobileOpen,
  setIsMobileOpen,
  isMobile,
}) => {
  const navigate = useNavigate();
  const { baseUrl, authToken, loggedInDeliveryMan } = useContext(MyContext);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const notificationRef = useRef(null);
  const [showMessages, setShowMessages] = useState(false);

  const fetchNotifications = () => {
    axios
      .get(`${baseUrl}/delivery/notifications/viewAllNotifications`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        if (response.data.success) {
          setNotifications(response.data.notifications);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (!authToken) return;
    fetchNotifications();
  }, [authToken]);

  // ── notification pe click: mark as read + notifications page
  // par navigate karo us particular notification ke sath ──
  const openNotification = (n) => {
    setShowNotifications(false);

    if (isUnread(n.status)) {
      const formData = new FormData();
      formData.append("id", n.id);

      axios
        .post(
          `${baseUrl}/delivery/notifications/changeNotificationStatus`,
          formData,
          {
            headers: { Authorization: `Bearer ${authToken}` },
          },
        )
        .then(() => {
          setNotifications((prev) =>
            prev.map((item) =>
              item.id === n.id ? { ...item, status: "read" } : item,
            ),
          );
        })
        .catch((error) => console.log(error));
    }

    navigate("/delivery/notifications", { state: { openNotification: n } });
  };

  useEffect(() => {
    const clickOutside = (e) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(e.target)
      )
        setShowNotifications(false);
    };
    document.addEventListener("mousedown", clickOutside);
    return () => document.removeEventListener("mousedown", clickOutside);
  }, []);

  const toggleSidebar = () => {
    if (isMobile) {
      setIsMobileOpen(!isMobileOpen);
    } else {
      setIsCollapsed(!isCollapsed);
    }
  };

  const unreadNotifications = notifications.filter((n) =>
    isUnread(n.status),
  ).length;

  return (
    <div className="del-topbar">
      {/* Toggle Button */}
      <button className="del-topbar__toggle" onClick={() => toggleSidebar()}>
        {isMobile ? (
          isMobileOpen ? (
            <MdClose />
          ) : (
            <MdMenu />
          )
        ) : isCollapsed ? (
          <FiChevronsRight />
        ) : (
          <FiChevronsLeft />
        )}
      </button>

      {/* Right Actions */}
      <div className="del-topbar__actions">
        {/* Notifications */}
        <div className="del-topbar__dropdown-wrap" ref={notificationRef}>
          <button
            className="del-topbar__icon-btn"

            onClick={() => { setShowNotifications(!showNotifications);  }}

          >
            <MdNotifications />
            {unreadNotifications > 0 && (
              <span className="del-topbar__badge">{unreadNotifications}</span>
            )}
          </button>

          {showNotifications && (
            <div className="del-topbar__dropdown">
              <div className="del-topbar__dropdown-header">
                <h6>Notifications</h6>
                <button
                  className="del-topbar__close-btn"
                  onClick={() => setShowNotifications(false)}
                >
                  <MdClose />
                </button>
              </div>
              <div className="del-topbar__dropdown-body">
                {notifications.map((notif) => (
                  <div
                    key={notif.id}
                    className={`del-topbar__dropdown-item ${
                      isUnread(notif.status)
                        ? "del-topbar__dropdown-item--unread"
                        : ""
                    }`}
                    onClick={() => openNotification(notif)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="del-topbar__notif-dot"></div>
                    <div className="del-topbar__notif-content">
                      <h6>{notif.title}</h6>
                      <p>{notif.message}</p>
                      <span>{getTimeAgo(notif.created_at)}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="del-topbar__dropdown-footer">
                <Link to="/delivery/notifications">View All Notifications</Link>
              </div>
            </div>
          )}
        </div>

        {/* Profile Dropdown */}
        <Dropdown>
          <Dropdown.Toggle as="div" className="del-topbar__profile">
            <div className="del-topbar__profile-info">
              {!isMobile && <h6>{loggedInDeliveryMan?.name}</h6>}
              <p>DELIVERY</p>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu align="end">
            <Dropdown.Item as={Link} to="/delivery/settings">
              <MdPerson /> My Profile
            </Dropdown.Item>
            <Dropdown.Item as={Link} to="/delivery/settings">
              <MdSettings /> Settings
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default DeliveryTopbar;
